import { resetRemoteVersion } from './remoteVersion';
import { resetDirtyKeys } from './dirtyKeys';
import { cancelDirtyFlush } from './dirtyFlush';
import { resetVoipQuality } from './voipQuality';
import { releaseDeckPrString } from './deckPrStringHold';
import { clearDepartedVoipPeers } from './voipPeerProbe';
import { clearEndPending } from './pendingEnd';

/**
 * Reset every module-global piece of session-sync state (AVS-4330). Entering a different session
 * invalidates the version gate (versions are per session record), the dirty set (in-flight edits
 * belong to the old session), and any scheduled re-send of those edits (AVS-4399). Grouping the
 * resets in one call keeps every session-switch entry point from wiring up only some of them.
 *
 * The VOIP quality counters (AVS-4419) reset here too, and here specifically: this is the one seam
 * that fires for exactly a NEW session id (`loadPublicSession`, `startNewSession`) and never for the
 * `session:start` re-emit on an already-active session — which fires on every car change during a
 * live call. That is the opposite contract from `syncTelemetry.ts`, whose counters are tab-lifetime
 * and deliberately survive this call.
 */
export function resetSessionSyncState(): void {
  resetRemoteVersion();
  resetDirtyKeys();
  cancelDirtyFlush();
  resetVoipQuality();
  releaseDeckPrString();
  clearDepartedVoipPeers();
  clearEndPending(undefined);
}
